import type { IControl, Map as MapLibreMap } from "maplibre-gl";

import { STATION_ROUTE_WAYPOINT_MAP_CTRL_MARGIN_TOP_PX } from "@ryde/shared";

/**
 * Hosts the waypoint toolbar in MapLibre's top-left control stack so it sits
 * under fullscreen + zoom, tighter than the default 10px group gap.
 */
export class WaypointMapLibreControl implements IControl {
  private readonly container: HTMLDivElement;

  constructor() {
    this.container = document.createElement("div");
    this.container.className = "maplibregl-ctrl";
    this.container.style.marginTop = `${STATION_ROUTE_WAYPOINT_MAP_CTRL_MARGIN_TOP_PX}px`;
  }

  onAdd(_map: MapLibreMap): HTMLElement {
    return this.container;
  }

  onRemove(): void {
    this.container.remove();
  }

  getContainer(): HTMLDivElement {
    return this.container;
  }
}
